import { safeStorageGet, safeStorageSet } from "./prefs";

export type ThemeChoice = "system" | "dark" | "light";
export const THEME_KEY = "music-platform:theme";

export function loadTheme(): ThemeChoice {
  const v = safeStorageGet(THEME_KEY);
  return v === "dark" || v === "light" ? v : "system";
}

/** Apply a theme choice to <html> (per-browser preference; not part of projects). */
export function applyTheme(choice: ThemeChoice, root: HTMLElement = document.documentElement): void {
  if (choice === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", choice);
}

export function saveTheme(choice: ThemeChoice): void {
  safeStorageSet(THEME_KEY, choice);
  applyTheme(choice);
}
